let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let esUtils = require("ES/utils/esUtils");
let AuthedUserSession = require("../../utils/AuthedUserSession");

let hasPro = function (sids) {
    if (AuthedUserSession.is_privatelabel) {
        return true;//privatelabels get everything
    }
    sids = esUtils.cleanup_ids(sids); //let sids = esUtils.cleanup_ids(_.flattenDeep(_.rest(_.toArray(arguments))));
    let pro_sids = AuthedUserSession.getSIDsAtPackageLevel("PRO");

    if (_.size(sids) > 0) {
        pro_sids = _.intersection(pro_sids, sids);
    }
    return _.size(pro_sids) > 0;
};

module.exports = dd.createClass({
    __unlock: esUtils.wrapPreventDefault(function () {
        window.open("/account-menu/upgrade-to-pro-from-starter/");
    }),
    render: function () {
        let custom_message = this.props.custom_message;

        if (hasPro(_.get(this.props, 'sids', []))) {
            return dd.div({className: "ProOnly has-pro"},
                this.props.children
            );
        }

        // NOTE
        // NOTE there are many places where this css is overridden so use caution when renaming/changing structure of the markup
        // NOTE
        return dd.div({className: "ProOnly relative clickable", onClick: this.__unlock},
            dd.div({className: "glass"}),
            dd.div({className: "pro-message"},
                dd.div({className: "title"},
                    dd.i({className: "fa fa-unlock-alt"}), " ", dd.a({href: "#", onClick: this.__unlock}, "Unlock PRO")
                ),
                custom_message ? dd.div({className: "custom_message"},
                    custom_message, dd.a({href: "#", onClick: this.__unlock}, " Learn more... ")
                ) : null
            ),
            this.props.children
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/widgets/ProOnly.js